import { IFRAME_HEIGHT_MAX, IFRAME_HEIGHT_MIN } from "@repo/shared";
// Local translations
export const T = {
  en_GB: {
    addComponent: "Add Component",
    toLeftColumn: "to Left Column",
    toRightColumn: "to Right Column",
    toPage: "to Page",
    configure: "Configure",
    selectComponentType: "Select the type of component you want to add",
    configureSettings: "Configure the component settings",
    componentSettingsTab: "Component Settings",
    conditionalDisplayTab: "Conditional Display",
    htmlTab: "HTML Code",
    cancel: "Cancel",
    next: "Next",
    addComponentBtn: "Add Component",
    back: "Back",

    // Field component
    selectField: "Select Field",
    noFieldsAvailable: "No fields available. Please create fields in the Fields tab first.",
    noFieldsForPageType:
      "No fields available for this page type. Goal-scoped fields can only be added to goal pages.",
    chooseField: "Choose a field",
    chooseFieldHint: "Choose which field to display on this page",
    quizSetupHint: "The client must pass this quiz before the flow can be submitted.",

    // Text block
    content: "Content",
    textPlaceholder:
      "Write the text — a heading, **bold**, *italic*, lists and links are supported",
    textHint:
      "One heading style and paragraphs. Use the toolbar or type # at the start of a line for a heading; it renders like every other component header.",

    // Spacer
    heightPixels: "Height (pixels)",
    heightHint: "Vertical spacing in pixels (1-500)",

    // Validation errors
    pleaseSelectField: "Please select a field",
    pleaseEnterTextContent: "Please enter text content",
    heightMustBeBetween: "Height must be between 1 and 500 pixels",
    pleaseEnterYoutubeUrl: "Please enter a YouTube URL",
    iframeUrlInvalid: "Please enter an absolute https:// web page URL",
    iframeUrlAppOrigin: "This URL points to the app itself and cannot be shown here",
    iframeHeightInvalid: `Height must be between ${IFRAME_HEIGHT_MIN} and ${IFRAME_HEIGHT_MAX} pixels`,
    pleaseUploadImage: "Please upload an image",
    pleaseEnterEmbedCode: "Please enter HTML embed code",
    pleaseEnterModalButtonLabel: "Please enter a button label",
    pleaseEnterModalTitle: "Please enter a popup title",
    pleaseEnterModalContent: "Please enter popup content",
    pleaseUploadDocument: "Please upload a document",
    pleaseSelectDisplayOption:
      "Please select at least one display option: Show Chart or Show Table",
    pleaseSelectTimeRange: "Please select at least one time range",
    pleaseSelectOneDisplayOption: "Please select at least one display option",
    pleaseSelectPortfolioType: "Please select at least one allowed portfolio type",

    // Risk Assessment
    riskAssessmentRequirements: "Requirements",
    riskAssessmentNote:
      "This component requires a risk model to be configured in the Flow Settings tab.",

    // Conditional display
  },
  nb_NO: {
    addComponent: "Legg til komponent",
    toLeftColumn: "til venstre kolonne",
    toRightColumn: "til høyre kolonne",
    toPage: "til side",
    configure: "Konfigurer",
    selectComponentType: "Velg hvilken type komponent du vil legge til",
    configureSettings: "Konfigurer komponentinnstillingene",
    componentSettingsTab: "Komponentinnstillinger",
    conditionalDisplayTab: "Betinget visning",
    htmlTab: "HTML-kode",
    cancel: "Avbryt",
    next: "Neste",
    addComponentBtn: "Legg til komponent",
    back: "Tilbake",

    // Field component
    selectField: "Velg felt",
    noFieldsAvailable: "Ingen felter tilgjengelig. Opprett felter i Felter-fanen først.",
    noFieldsForPageType:
      "Ingen felter tilgjengelig for denne sidetypen. Mål-felter kan kun legges til på målsider.",
    chooseField: "Velg et felt",
    chooseFieldHint: "Velg hvilket felt som skal vises på denne siden",
    quizSetupHint: "Kunden må bestå denne quizen før flyten kan sendes inn.",

    // Text block
    content: "Innhold",
    textPlaceholder: "Skriv teksten — overskrift, **fet**, *kursiv*, lister og lenker støttes",
    textHint:
      "Én overskriftsstil og avsnitt. Bruk verktøylinjen eller skriv # først på linjen for en overskrift; den vises som alle andre komponentoverskrifter.",

    // Spacer
    heightPixels: "Høyde (piksler)",
    heightHint: "Vertikal avstand i piksler (1-500)",

    // Validation errors
    pleaseSelectField: "Vennligst velg et felt",
    pleaseEnterTextContent: "Vennligst skriv inn tekstinnhold",
    heightMustBeBetween: "Høyden må være mellom 1 og 500 piksler",
    pleaseEnterYoutubeUrl: "Vennligst skriv inn en YouTube-URL",
    iframeUrlInvalid: "Vennligst skriv inn en absolutt https://-nettside-URL",
    iframeUrlAppOrigin: "Denne adressen peker til selve appen og kan ikke vises her",
    iframeHeightInvalid: `Høyden må være mellom ${IFRAME_HEIGHT_MIN} og ${IFRAME_HEIGHT_MAX} piksler`,
    pleaseUploadImage: "Vennligst last opp et bilde",
    pleaseEnterEmbedCode: "Vennligst skriv inn HTML-innebyggingskode",
    pleaseEnterModalButtonLabel: "Vennligst skriv inn en knappetekst",
    pleaseEnterModalTitle: "Vennligst skriv inn en popup-tittel",
    pleaseEnterModalContent: "Vennligst skriv inn popup-innhold",
    pleaseUploadDocument: "Vennligst last opp et dokument",
    pleaseSelectDisplayOption:
      "Vennligst velg minst ett visningsalternativ: Vis diagram eller Vis tabell",
    pleaseSelectTimeRange: "Vennligst velg minst ett tidsrom",
    pleaseSelectOneDisplayOption: "Vennligst velg minst ett visningsalternativ",
    pleaseSelectPortfolioType: "Vennligst velg minst én tillatt porteføljetype",

    // Risk Assessment
    riskAssessmentRequirements: "Krav",
    riskAssessmentNote:
      "Denne komponenten krever at en risikomodell er konfigurert i Flytinnstillinger-fanen.",

    // Conditional display
  },
} as const;
